import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'

export const useBookingsDeleteMutation = (onSettled: () => void) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: bookingsDeleteMutation } = useMutation({
		mutationFn: (ids: number[]) => axiosPrivate.post(apiRoutes.bookingsDelete, { ids }),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.bookings.all })
			useToast({
				type: 'success',
				message: t('Bookings deleted')
			})()
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		bookingsDeleteMutation
	}
}
